import { motion, AnimatePresence } from "framer-motion";
import { Field, Text, Area, Select } from "../FormFields";
import { PORTS } from "../../data/content";

const reveal = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: "auto" },
  exit: { opacity: 0, height: 0 },
  transition: { duration: 0.35 },
};

export const LUGGAGE = ["0", "1", "2", "3", "4", "5", "6", "7", "8+"];
const ALL_PORTS = [...PORTS.cruise, ...PORTS.yacht];

export function ContactFields({ t, errors, form, set, passengerOptions, serviceTypes }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <Field label={t("form.fullName")} testid="field-name" error={errors.full_name}>
        <Text testid="input-name" error={errors.full_name} value={form.full_name} onChange={set("full_name")} placeholder={t("form.fullNamePh")} />
      </Field>
      <Field label={t("form.passengers")} testid="field-passengers" error={errors.passengers}>
        <Select testid="input-passengers" error={errors.passengers} options={passengerOptions} value={form.passengers} onChange={set("passengers")} placeholder={t("form.passengersPh")} />
      </Field>
      <Field label={t("form.email")} testid="field-email" error={errors.email}>
        <Text testid="input-email" error={errors.email} type="email" value={form.email} onChange={set("email")} placeholder={t("form.emailPh")} />
      </Field>
      <Field label={t("form.confirmEmail")} testid="field-confirm-email" error={errors.confirm_email}>
        <Text testid="input-confirm-email" error={errors.confirm_email} type="email" value={form.confirm_email} onChange={set("confirm_email")} placeholder={t("form.confirmEmailPh")} onPaste={(e) => e.preventDefault()} />
      </Field>
      <Field label={t("form.serviceType")} testid="field-service-type" error={errors.service_type}>
        <Select testid="input-service-type" error={errors.service_type} options={serviceTypes} value={form.service_type} onChange={set("service_type")} placeholder={t("form.serviceTypePh")} />
      </Field>
      <div className="hidden md:block" />
      <Field label={t("form.date")} testid="field-date" error={errors.service_date}>
        <Text testid="input-date" error={errors.service_date} type="date" value={form.service_date} onChange={set("service_date")} />
      </Field>
      <Field label={t("form.pickupTime")} testid="field-time" error={errors.pickup_time}>
        <Text testid="input-time" error={errors.pickup_time} type="time" value={form.pickup_time} onChange={set("pickup_time")} />
      </Field>
    </div>
  );
}

function AirportPickup({ t, errors, d, modeOptions, pickupMode, changePickupMode, setDetail, setLoc }) {
  return (
    <>
      <Field label={t("form.pickupFrom")} testid="field-pickup-mode">
        <Select testid="input-pickup-mode" options={modeOptions} value={pickupMode} onChange={changePickupMode} placeholder={t("form.select")} />
      </Field>
      <Field label={t("form.flightNumber")} testid="field-flight" error={errors.flight_number}>
        <Text testid="input-flight" error={errors.flight_number} value={d.flight_number || ""} onChange={setDetail("flight_number")} placeholder={t("form.flightNumberPh")} />
      </Field>
      <Field label={t("form.flightOrigin")} testid="field-flight-origin" error={errors.flight_origin}>
        <Text testid="input-flight-origin" error={errors.flight_origin} value={d.flight_origin || ""} onChange={setDetail("flight_origin")} placeholder={t("form.flightOriginPh")} />
      </Field>
      <Field label={t("form.dropoffAddress")} testid="field-dropoff" error={errors.dropoff_address}>
        <Text testid="input-dropoff" error={errors.dropoff_address} value={d.dropoff_address || ""} onChange={setLoc("dropoff_address")} placeholder={t("form.dropoffAddressPh")} />
      </Field>
      <Field label={t("form.hotel")} testid="field-hotel" error={errors.hotel}>
        <Text testid="input-hotel" error={errors.hotel} value={d.hotel || ""} onChange={setLoc("hotel")} placeholder={t("form.hotelPh")} />
      </Field>
      <Field label={t("form.cityDropoff")} testid="field-city-dropoff" error={errors.city_of_dropoff}>
        <Text testid="input-city-dropoff" error={errors.city_of_dropoff} value={d.city_of_dropoff || ""} onChange={setDetail("city_of_dropoff")} placeholder={t("form.cityDropoffPh")} />
      </Field>
    </>
  );
}

function PortPickup({ t, errors, d, modeOptions, pickupMode, changePickupMode, setDetail, setLoc }) {
  return (
    <>
      <Field label={t("form.pickupFrom")} testid="field-pickup-mode">
        <Select testid="input-pickup-mode" options={modeOptions} value={pickupMode} onChange={changePickupMode} placeholder={t("form.select")} />
      </Field>
      <Field label={t("form.portName")} testid="field-port-name" error={errors.port_name}>
        <Select testid="input-port-name" error={errors.port_name} options={ALL_PORTS} value={d.port_name || ""} onChange={setDetail("port_name")} placeholder={t("form.portNamePh")} />
      </Field>
      <Field label={t("form.dropoffAddress")} testid="field-dropoff" error={errors.dropoff_address}>
        <Text testid="input-dropoff" error={errors.dropoff_address} value={d.dropoff_address || ""} onChange={setLoc("dropoff_address")} placeholder={t("form.dropoffAddressPh")} />
      </Field>
      <Field label={t("form.hotel")} testid="field-hotel" error={errors.hotel}>
        <Text testid="input-hotel" error={errors.hotel} value={d.hotel || ""} onChange={setLoc("hotel")} placeholder={t("form.hotelPh")} />
      </Field>
      <Field label={t("form.cityDropoff")} testid="field-city-dropoff" error={errors.city_of_dropoff}>
        <Text testid="input-city-dropoff" error={errors.city_of_dropoff} value={d.city_of_dropoff || ""} onChange={setDetail("city_of_dropoff")} placeholder={t("form.cityDropoffPh")} />
      </Field>
    </>
  );
}

function AddressPickup({ t, errors, d, modeOptions, pickupMode, changePickupMode, setDetail, setLoc, setDropLoc }) {
  return (
    <>
      <Field label={t("form.hotel")} testid="field-hotel" error={errors.hotel}>
        <Text testid="input-hotel" error={errors.hotel} value={d.hotel || ""} onChange={setLoc("hotel")} placeholder={t("form.hotelPh")} />
      </Field>
      <Field label={t("form.pickupFrom")} testid="field-pickup-mode">
        <Select testid="input-pickup-mode" options={modeOptions} value={pickupMode} onChange={changePickupMode} placeholder={t("form.select")} />
      </Field>
      <Field label={t("form.pickupAddress")} testid="field-pickup-address" error={errors.pickup_address}>
        <Text testid="input-pickup-address" error={errors.pickup_address} value={d.pickup_address || ""} onChange={setLoc("pickup_address")} placeholder={t("form.pickupAddressPh")} />
      </Field>
      <Field label={t("form.cityPickup")} testid="field-city-pickup" error={errors.city_of_pickup}>
        <Text testid="input-city-pickup" error={errors.city_of_pickup} value={d.city_of_pickup || ""} onChange={setDetail("city_of_pickup")} placeholder={t("form.cityPickupPh")} />
      </Field>
      <Field label={t("form.dropoffHotel")} testid="field-dropoff-hotel" error={errors.dropoff_hotel}>
        <Text testid="input-dropoff-hotel" error={errors.dropoff_hotel} value={d.dropoff_hotel || ""} onChange={setDropLoc("dropoff_hotel")} placeholder={t("form.hotelPh")} />
      </Field>
      <Field label={t("form.dropoffAddress")} testid="field-dropoff" error={errors.dropoff_address}>
        <Text testid="input-dropoff" error={errors.dropoff_address} value={d.dropoff_address || ""} onChange={setDropLoc("dropoff_address")} placeholder={t("form.dropoffAddressPh")} />
      </Field>
      <Field label={t("form.cityDropoff")} testid="field-city-dropoff" error={errors.city_of_dropoff}>
        <Text testid="input-city-dropoff" error={errors.city_of_dropoff} value={d.city_of_dropoff || ""} onChange={setDetail("city_of_dropoff")} placeholder={t("form.cityDropoffPh")} />
      </Field>
    </>
  );
}

function ReturnFields({ t, errors, d, modeOptions, returnMode, changeReturnMode, setDetail }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-6">
      <Field label={t("form.returnDate")} testid="field-return-date" error={errors.return_date}>
        <Text testid="input-return-date" error={errors.return_date} type="date" value={d.return_date || ""} onChange={setDetail("return_date")} />
      </Field>
      <Field label={t("form.returnTime")} testid="field-return-time" error={errors.return_time}>
        <Text testid="input-return-time" error={errors.return_time} type="time" value={d.return_time || ""} onChange={setDetail("return_time")} />
      </Field>
      <Field label={t("form.returnMode")} testid="field-return-mode">
        <Select testid="input-return-mode" options={modeOptions} value={returnMode} onChange={changeReturnMode} placeholder={t("form.select")} />
      </Field>
      {returnMode === "airport" ? (
        <>
          <Field label={t("form.returnFlight")} testid="field-return-flight" error={errors.return_flight_number}>
            <Text testid="input-return-flight" error={errors.return_flight_number} value={d.return_flight_number || ""} onChange={setDetail("return_flight_number")} placeholder={t("form.flightNumberPh")} />
          </Field>
          <Field label={t("form.returnFlightOrigin")} testid="field-return-flight-origin" error={errors.return_flight_origin}>
            <Text testid="input-return-flight-origin" error={errors.return_flight_origin} value={d.return_flight_origin || ""} onChange={setDetail("return_flight_origin")} placeholder={t("form.flightOriginPh")} />
          </Field>
        </>
      ) : returnMode === "port" ? (
        <Field label={t("form.returnPort")} testid="field-return-port" error={errors.return_port_name}>
          <Select testid="input-return-port" error={errors.return_port_name} options={ALL_PORTS} value={d.return_port_name || ""} onChange={setDetail("return_port_name")} placeholder={t("form.portNamePh")} />
        </Field>
      ) : (
        <Field label={t("form.returnAddress")} testid="field-return-address" error={errors.return_address}>
          <Text testid="input-return-address" error={errors.return_address} value={d.return_address || ""} onChange={setDetail("return_address")} placeholder={t("form.returnAddressPh")} />
        </Field>
      )}
      <Field label={t("form.luggage")} testid="field-return-luggage" error={errors.return_luggage}>
        <Select testid="input-return-luggage" error={errors.return_luggage} options={LUGGAGE} value={d.return_luggage || ""} onChange={setDetail("return_luggage")} placeholder={t("form.luggagePh")} />
      </Field>
    </div>
  );
}

const PICKUP_COMPONENTS = { airport: AirportPickup, port: PortPickup };

export function PointToPointFields(props) {
  const { t, errors, d, pickupMode, setDetail, returnTrip, setReturnTrip, returnMode } = props;
  const Pickup = PICKUP_COMPONENTS[pickupMode] || AddressPickup;
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-2">
        <Pickup {...props} />
        <Field label={t("form.luggage")} testid="field-luggage" error={errors.luggage}>
          <Select testid="input-luggage" error={errors.luggage} options={LUGGAGE} value={d.luggage || ""} onChange={setDetail("luggage")} placeholder={t("form.luggagePh")} />
        </Field>
      </div>
      <div className="pt-6">
        <label className="flex items-center gap-3 cursor-pointer text-white/80 text-sm" data-testid="check-return">
          <input type="checkbox" className="accent-[#C5A059] h-4 w-4" checked={returnTrip} onChange={(e) => setReturnTrip(e.target.checked)} />
          {t("form.needReturn")}
        </label>
      </div>
      <AnimatePresence>
        {returnTrip && (
          <motion.div key="ret" {...reveal} className="overflow-hidden">
            <ReturnFields {...props} returnMode={returnMode} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export function PrivateItineraryFields({ t, errors, d, setDetail }) {
  return (
    <div className="grid grid-cols-1 gap-8 pt-2">
      <Field label={t("form.piPickup")} testid="field-pi-pickup" error={errors.pickup_address}>
        <Text testid="input-pi-pickup" error={errors.pickup_address} value={d.pickup_address || ""} onChange={setDetail("pickup_address")} placeholder={t("form.piPickupPh")} />
      </Field>
      <Field label={t("form.describeDay")} testid="field-pi-notes" error={errors.requests}>
        <Area testid="input-pi-notes" error={errors.requests} value={d.requests || ""} onChange={setDetail("requests")} placeholder={t("form.describeDayPh")} />
      </Field>
    </div>
  );
}

export function ShoreExcursionFields({ t, errors, d, setDetail }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-2">
      <Field label={t("form.shipName")} testid="field-ship" error={errors.ship_name}>
        <Text testid="input-ship" error={errors.ship_name} value={d.ship_name || ""} onChange={setDetail("ship_name")} placeholder={t("form.shipNamePh")} />
      </Field>
      <Field label={t("form.arrivalPort")} testid="field-port" error={errors.port}>
        <Select testid="input-port" error={errors.port} options={PORTS.cruise} value={d.port || ""} onChange={setDetail("port")} placeholder={t("form.arrivalPortPh")} />
      </Field>
    </div>
  );
}

export function HoursDispositionFields({ t, errors, d, setDetail }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-2">
      <Field label={t("form.piPickup")} testid="field-hd-pickup" error={errors.pickup_address}>
        <Text testid="input-hd-pickup" error={errors.pickup_address} value={d.pickup_address || ""} onChange={setDetail("pickup_address")} placeholder={t("form.cityPickupPh")} />
      </Field>
      <Field label={t("form.destination")} testid="field-hd-dest" error={errors.destination}>
        <Text testid="input-hd-dest" error={errors.destination} value={d.destination || ""} onChange={setDetail("destination")} placeholder={t("form.destinationPh")} />
      </Field>
      <Field label={t("form.hours")} testid="field-hd-hours" error={errors.hours}>
        <Text testid="input-hd-hours" error={errors.hours} value={d.hours || ""} onChange={setDetail("hours")} placeholder={t("form.hoursPh")} />
      </Field>
      <Field label={t("form.additional")} testid="field-hd-notes">
        <Text testid="input-hd-notes" value={d.requests || ""} onChange={setDetail("requests")} placeholder={t("form.additionalPh")} />
      </Field>
    </div>
  );
}
